import React from "react";
import ArrangementPane from './ArrangementPane';
import BreadCrumbsPage from '../../drive/cards/BreadCrumbs'
import { withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import DisplayGeneratedSchema from "../../../../drive/FormBuilder/DisplaySurveySchema";
class AdditionalIformation extends React.Component {

    componentWillMount = async () => {
        await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.match.params.playbookId);
        dispatch.app.setRouteParams(this.props.match.params);
    }

    onSubmitSchema = (schema) => {
        let payload = {
            _id: this.props.selectedPracticeLibrary._id,
            data: {
                metaDataSchema: schema
            }
        }
        dispatch.lifeCycle.updatePlaybook(payload);
    }

     isAuthor = () => {
        const loggdinUserId = this.props.user.email;
        let author =
        this.props.selectedPracticeLibrary &&
        this.props.selectedPracticeLibrary.participants &&
        this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "author";
        });
        if (author && author.length > 0) {
        return author.find((author) => author.email === loggdinUserId);
        }
        return null;
  };

    isWorkspaceOwner = () => {
        let authors =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "workspaceOwner"
          );
        if (authors && authors.length > 0) {
          return true;
        }
        return null;
      };

       isContributor = () => {
        const loggdinUserId = this.props.user.email;
        let contributor =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "contributor";
          });
        if (contributor && contributor.length > 0) {
          return contributor.find((contributor) => contributor.email === loggdinUserId);
        }
        return null;
      };

    render() {
        return (
            <div className="overflow-hide pad_20"  >
                <ArrangementPane {...this.props} setPage="AdditionalInformation" />
                <BreadCrumbsPage {...this.props} />

                <DisplayGeneratedSchema
                    editAccess={this.props.selectedPracticeLibrary.status === 0 || (this.props.selectedPracticeLibrary.status === 4 && (this.isAuthor() || this.isWorkspaceOwner() || this.isContributor()))}
                    schema={this.props.selectedPracticeLibrary.metaDataSchema}
                    onSubmitSchema={this.onSubmitSchema}
                />
            </div>
        )
    }
}




export default withRouter(AdditionalIformation);